<button cs-capture-cover (click)="handleClick($event)" [disabled]="disabled"></button>
<span class="tab-content-wrapper">
  <ng-content></ng-content>
  @if (showNotification) {
    <span class="notification-dot"></span>
  }
</span>
